import { render, staticRenderFns } from "./TourComponent.vue?vue&type=template&id=b6b70a18&scoped=true&"
import script from "./TourComponent.vue?vue&type=script&lang=js&"
export * from "./TourComponent.vue?vue&type=script&lang=js&"
import style0 from "./TourComponent.vue?vue&type=style&index=0&id=b6b70a18&lang=scss&scoped=true&"
import style1 from "./TourComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b70a18",
  null
  
)

export default component.exports